import en from "./localeEn";
import es from "./localeEs";
import pt from "./localePt";
export var localeEs = es;
export var localePt = pt;
export var localeEn = en;
var locales = {
  es: es,
  pt: pt,
  en: en
};
export default locales;